import { KeyboardEvent, useCallback } from 'react';
import { useStepViewerNavigation } from './useStepViewerNavigation';

type UseStepViewerNavigateOnEnterProps = {
  eventId?: string;
  callback?: () => void;
};

export const useStepViewerNavigateOnEnter = ({
  eventId,
  callback
}: UseStepViewerNavigateOnEnterProps) => {
  const { next } = useStepViewerNavigation({ eventId });

  const handleKeyUp = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        callback?.();
      }
    },
    [callback, eventId, next]
  );

  return {
    handleKeyUp
  };
};
